import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "config-balanca"
  }, [_c('div', {
    staticClass: "config-balanca__header"
  }, [_vm._m(0), _c('span', {
    class: ['config-balanca__status', "config-balanca__status--".concat(_vm.status.tipo)]
  }, [_c('i', {
    class: _vm.status.icone
  }), _vm._v(_vm._s(_vm.status.texto) + " ")])]), _vm.mensagem ? _c('div', {
    class: ['config-balanca__alert', _vm.erro ? 'config-balanca__alert--erro' : 'config-balanca__alert--sucesso']
  }, [_c('i', {
    class: _vm.erro ? 'fas fa-exclamation-circle' : 'fas fa-check-circle'
  }), _vm._v(" " + _vm._s(_vm.mensagem) + " ")]) : _vm._e(), _c('div', {
    staticClass: "config-balanca__card"
  }, [_c('div', {
    staticClass: "config-balanca__switch-row"
  }, [_vm._m(1), _c('label', {
    staticClass: "config-balanca__switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.habilitada,
      expression: "form.habilitada"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.habilitada) ? _vm._i(_vm.form.habilitada, null) > -1 : _vm.form.habilitada
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.habilitada,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "habilitada", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "habilitada", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "habilitada", $$c);
        }
      }
    }
  }), _c('span')])]), _c('fieldset', {
    attrs: {
      "disabled": _vm.ocupado || !_vm.form.habilitada
    }
  }, [_vm._m(2), _c('div', {
    staticClass: "config-balanca__grid"
  }, [_c('label', [_vm._v(" Modelo da balança "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.modelo,
      expression: "form.modelo"
    }],
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.aplicarPadraoModelo]
    }
  }, _vm._l(_vm.modelos, function (modelo) {
    return _c('option', {
      key: modelo.codigo,
      domProps: {
        "value": modelo.codigo
      }
    }, [_vm._v(" " + _vm._s(modelo.nome) + " ")]);
  }), 0)]), _c('label', [_vm._v(" Porta serial "), _c('div', {
    staticClass: "config-balanca__input-action"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.portaSerial,
      expression: "form.portaSerial"
    }],
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "portaSerial", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.form.adaptadorId = '';
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a porta")]), _vm.portaSalvaNaoListada ? _c('option', {
    domProps: {
      "value": _vm.form.portaSerial
    }
  }, [_vm._v(" " + _vm._s(_vm.form.portaSerial) + " ")]) : _vm._e(), _vm._l(_vm.portas, function (porta) {
    return _c('option', {
      key: porta.path,
      domProps: {
        "value": porta.path
      }
    }, [_vm._v(" " + _vm._s(porta.nome) + " ")]);
  })], 2), _c('button', {
    attrs: {
      "type": "button",
      "title": "Atualizar portas"
    },
    on: {
      "click": _vm.carregarPortas
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  })])])]), _c('label', [_vm._v(" Velocidade "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.baudRate,
      expression: "form.baudRate",
      modifiers: {
        "number": true
      }
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.form, "baudRate", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 9600
    }
  }, [_vm._v("9600 baud (recomendado)")]), _c('option', {
    domProps: {
      "value": 4800
    }
  }, [_vm._v("4800 baud")]), _c('option', {
    domProps: {
      "value": 2400
    }
  }, [_vm._v("2400 baud")])])]), _c('label', [_vm._v(" Resolução do peso "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.casasDecimais,
      expression: "form.casasDecimais",
      modifiers: {
        "number": true
      }
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.form, "casasDecimais", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("0,001 kg (3 casas)")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("0,01 kg (2 casas)")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("0,1 kg (1 casa)")])])])]), _c('button', {
    staticClass: "config-balanca__detect-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.ocupado
    },
    on: {
      "click": _vm.detectar
    }
  }, [_c('span', {
    staticClass: "config-balanca__detect-icon"
  }, [_c('i', {
    class: _vm.detectando ? 'fas fa-spinner fa-spin' : 'fas fa-search'
  })]), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.detectando ? "Detectando balança..." : "Detectar automaticamente"))]), _c('small', [_vm._v("Testa as portas e velocidades disponíveis neste computador.")])]), _c('i', {
    staticClass: "fas fa-chevron-right"
  })]), _c('details', {
    staticClass: "config-balanca__advanced"
  }, [_c('summary', [_vm._v("Configuração avançada de estabilização")]), _c('div', {
    staticClass: "config-balanca__advanced-grid"
  }, [_c('label', [_vm._v(" Tolerância "), _c('div', {
    staticClass: "config-balanca__number-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.toleranciaG,
      expression: "form.toleranciaG",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1000"
    },
    domProps: {
      "value": _vm.form.toleranciaG
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "toleranciaG", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("g")])])]), _c('label', [_vm._v(" Amostras estáveis "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.amostrasJanela,
      expression: "form.amostrasJanela",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "2",
      "max": "50"
    },
    domProps: {
      "value": _vm.form.amostrasJanela
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "amostrasJanela", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', [_vm._v(" Peso mínimo "), _c('div', {
    staticClass: "config-balanca__number-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.pesoMinimoG,
      expression: "form.pesoMinimoG",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10000"
    },
    domProps: {
      "value": _vm.form.pesoMinimoG
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "pesoMinimoG", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("g")])])]), _c('label', [_vm._v(" Intervalo de leitura "), _c('div', {
    staticClass: "config-balanca__number-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.intervaloMs,
      expression: "form.intervaloMs",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "100",
      "max": "5000"
    },
    domProps: {
      "value": _vm.form.intervaloMs
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "intervaloMs", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("ms")])])])])])]), _c('div', {
    staticClass: "config-balanca__diagnostico"
  }, [_c('div', [_c('span', [_vm._v("Conexão")]), _c('strong', {
    class: {
      'config-balanca__ok': _vm.diagnostico.conectado
    }
  }, [_vm._v(" " + _vm._s(_vm.diagnostico.conectado ? "Conectada" : "Desconectada") + " ")])]), _c('div', [_c('span', [_vm._v("Porta em uso")]), _c('strong', [_vm._v(_vm._s(_vm.diagnostico.porta || "—"))])]), _c('div', [_c('span', [_vm._v("Velocidade")]), _c('strong', [_vm._v(_vm._s(_vm.diagnostico.baudRate ? "".concat(_vm.diagnostico.baudRate, " baud") : "—"))])]), _c('div', [_c('span', [_vm._v("Último peso")]), _c('strong', [_vm._v(_vm._s(_vm.pesoFormatado))])])]), _c('div', {
    staticClass: "config-balanca__actions"
  }, [_c('button', {
    staticClass: "config-balanca__btn config-balanca__btn--outline",
    attrs: {
      "disabled": _vm.ocupado || !_vm.form.habilitada || !_vm.form.portaSerial
    },
    on: {
      "click": _vm.testar
    }
  }, [_c('i', {
    class: _vm.testando ? 'fas fa-spinner fa-spin mr-1' : 'fas fa-vial mr-1'
  }), _vm._v(" " + _vm._s(_vm.testando ? "Lendo peso..." : "Testar leitura") + " ")]), _c('button', {
    staticClass: "config-balanca__btn config-balanca__btn--primary",
    attrs: {
      "disabled": _vm.ocupado
    },
    on: {
      "click": _vm.salvar
    }
  }, [_c('i', {
    class: _vm.salvando ? 'fas fa-spinner fa-spin mr-1' : 'fas fa-save mr-1'
  }), _vm._v(" " + _vm._s(_vm.salvando ? "Salvando..." : "Salvar configuração") + " ")])])]), _vm._m(3)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "config-balanca__eyebrow"
  }, [_vm._v("PERIFÉRICOS DO TERMINAL")]), _c('h2', [_c('i', {
    staticClass: "fas fa-weight mr-2"
  }), _vm._v("Balança de checkout")]), _c('p', [_vm._v(" Configure a balança conectada diretamente a este PDV Desktop. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Usar balança neste terminal")]), _c('small', [_vm._v(" Produtos marcados como “pesado” aguardarão o peso estabilizar. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "config-balanca__section-heading"
  }, [_c('span', {
    staticClass: "config-balanca__section-icon"
  }, [_c('i', {
    staticClass: "fas fa-plug"
  })]), _c('div', [_c('strong', [_vm._v("Conexão serial")]), _c('small', [_vm._v("USB ou RS-232 conectado diretamente ao computador.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "config-balanca__info"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _c('span', [_vm._v(" Para a Toledo Prix 3 Fit, configure "), _c('strong', [_vm._v("C-13 = SERIAL")]), _vm._v(", "), _c('strong', [_vm._v("C-14 = Prt5")]), _vm._v(" e "), _c('strong', [_vm._v("C-15 = 9600")]), _vm._v(". O PDV Desktop faz toda a leitura, sem outro aplicativo aberto. ")])]);
}];
export { render, staticRenderFns };